module.exports = __webpack_public_path__ + "i18n/ja.b116188e56540bff3d64638946c71429.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1060
// module chunks = 60